import styled from "styled-components";
import { colors } from "../../../utils/styles";
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles";

export const CaseStudiesHeroWrapper = styled.section`
	.container {
		font-family: Poppins, sans-serif;
	}

	.hero-text {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 2.7rem;
		text-align: center;
		margin-block: 5.7rem;

		.tag {
			padding: 1rem 1.5rem;
			border-radius: 1rem;
			background-color: #e7ecee;
			color: #144056;
			font-weight: 600;
			line-height: 1;
		}

		h1 {
			margin: 0;

			text-wrap: balance;
			font-size: 56px;
			line-height: 1.2;
			font-weight: bold;
			font-family: Ambit, sans-serif;

			@media screen and (max-width: ${FlexipageColors.breakpointTablet}) {
				font-size: 48px;
			}

			@media screen and (max-width: ${FlexipageColors.breakpointMobile}) {
				font-size: 40px;
			}
		}
	}

	.sub-hero {
		display: grid;
		grid-template-columns: auto minmax(345px, 1fr);
		grid-template-rows: auto 1fr;
		gap: 2rem 2.5rem;

		> h2 {
			grid-column: 2;
			grid-row: 1;

			margin: 0;

			text-wrap: balance;
			color: #144056;
			font-size: ${headingSizes.h4.desktop[0]};
			line-height: ${headingSizes.h4.desktop[1]};
			font-family: ${headingSizes.h4.fontFamily};
			font-weight: ${headingSizes.h4.fontWeight};

			@media (max-width: ${FlexipageColors.breakpointTablet}) {
				font-size: ${headingSizes.h4.tablet[0]};
				line-height: ${headingSizes.h4.tablet[1]};
			}

			@media (max-width: ${FlexipageColors.breakpointMobile}) {
				font-size: ${headingSizes.h4.mobile[0]};
				line-height: ${headingSizes.h4.mobile[1]};
			}
		}

		> img {
			grid-column: 1;
			grid-row: 1 / -1;

			display: block;
			width: 100%;
			max-width: 478px;
			border-radius: 1rem;
			overflow: hidden;
		}

		> .box {
			grid-column: 2;
			grid-row: 2;
			align-self: start;

			margin-left: -120px;

			background-color: ${colors.secondaryBlue2};
			color: white;
			border-radius: 1rem;
			padding: 2rem;

			font-size: 1.125rem;
			line-height: 1.6;

			p {
				margin-bottom: 2rem;
				color: inherit;
			}

			.btn {
				display: inline-flex;
				align-items: center;
				gap: 0.5rem;

				background: ${colors.primaryBlue};
				color: white;
				font-weight: 500;
				border-radius: 0.5rem;
				padding: 0.75rem 1.5rem;
				text-align: left;

				&:hover,
				&:focus-visible {
					background-color: ${FlexipageColors.blue1200};
				}

				&:focus {
					box-shadow: none;
				}

				&:focus-visible {
					outline: 2px solid ${FlexipageColors.blue1000};
					outline-offset: 2px;
				}

				svg {
					height: 1rem;
					color: inherit;
					flex-shrink: 0;
				}
			}
		}

		@media screen and (max-width: ${FlexipageColors.breakpointMobile}) {
			display: flex;
			flex-direction: column;
			gap: 0;

			h2 {
				margin-bottom: 1.5rem;
			}

			> img {
				max-width: none;
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}

			> .box {
				border-top-left-radius: 0;
				border-top-right-radius: 0;
				margin-left: 0;
			}
		}
	}
`